import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0012',
    ecrans: ['00-2'],
    params: ['?loecleint','?efface_criteres']
});
